// External dependencies
import jQuery from 'jquery';

// Wordpress dependencies
import apiFetch from '@wordpress/api-fetch';

// jQuery( document ).ready( () => {
// 	jQuery( '.post-type-coca_bais form#post' ).on( 'submit', ( ) => {
// 		// Saved data from browser storage.
// 		const savedOptions = window.localStorage.getItem( 'coca_bais_data' );

// 		if ( !! savedOptions && !! JSON.parse( savedOptions ) ) {
// 			apiFetch( { path: '/coca-bais/v1/save-post-meta', method: 'post', data: JSON.parse( savedOptions ) } );
// 		}

// 		// Just land here.
// 		// event.preventDefault();
// 	} );
// } );
jQuery(document).ready(function() {
    var lastClickedButton = null;
    var isProcessing = false;
    
    // Cross-browser button capture
    function captureButtonClick() {
        jQuery('.post-type-coca_bais form#post input[type="submit"], .post-type-coca_bais form#post button[type="submit"]').on('click touchstart', function(e) {
            lastClickedButton = jQuery(this);
            
            // Store additional button info for cross-browser compatibility
            lastClickedButton.clickedAt = Date.now();
            lastClickedButton.buttonName = jQuery(this).attr('name') || '';
            lastClickedButton.buttonValue = jQuery(this).val() || jQuery(this).text() || '';
            lastClickedButton.buttonId = jQuery(this).attr('id') || '';
        });
    }
    
    // Initialize button capture
    captureButtonClick();
    
    // Cross-browser publish action detection
    function isPublishAction(button) {
        if (!button) return false;
        
        var name = button.buttonName || button.attr('name') || '';
        var value = button.buttonValue || button.val() || button.text() || '';
        var id = button.buttonId || button.attr('id') || '';
        var className = button.attr('class') || '';
        
        return (
            name === 'publish' || 
            value === 'Publish' ||
            value.indexOf('Publish') !== -1 ||
            id === 'publish' ||
            id.indexOf('publish') !== -1 ||
            className.indexOf('publish') !== -1 ||
            className.indexOf('editor-post-publish-button') !== -1
        );
    }
    
    // Form submission handler
    jQuery('.post-type-coca_bais form#post').on('submit', function(event) {
        // Prevent double processing
        if (isProcessing) {
            return false;
        }
        
        var savedOptions;
        try {
            savedOptions = window.localStorage.getItem('coca_bais_data');
        } catch (e) {
            // localStorage not supported or blocked
            console.warn('localStorage not available:', e);
            return; // Let form submit normally
        }
        
        if (!savedOptions) return; // Let form submit normally
        
        var form = this;
        var clickedButton = lastClickedButton;
        
        // Fallback button detection for browsers that don't capture click properly
        if (!clickedButton || (Date.now() - (clickedButton.clickedAt || 0)) > 5000) {
            // Look for recently focused elements or form submitter
            clickedButton = jQuery(document.activeElement);
            
            // If that doesn't work, look for publish buttons in the form
            if (!clickedButton || !clickedButton.is('input, button')) {
                clickedButton = jQuery(form).find('input[name="publish"], button[name="publish"], #publish, .editor-post-publish-button').first();
            }
        }
        
        var publishAction = isPublishAction(clickedButton);
        
        var parsedData;
        try {
            parsedData = JSON.parse(savedOptions);
        } catch (e) {
            console.error('Invalid localStorage JSON:', e);
            
            var continueAnyway = confirm('Invalid meta data format. Do you want to continue anyway?');
            if (!continueAnyway) {
                event.preventDefault();
                return false;
            }
            return; // Let form submit normally
        }
        
        if (parsedData && typeof parsedData === 'object') {
            event.preventDefault();
            isProcessing = true;
            
            // Prepare API data
            parsedData.post_id = jQuery('#post_ID').val();
            parsedData.intended_status = publishAction ? 'publish' : 'draft';
            
            // Cross-browser API call with fallback
            var apiCall;
            if (typeof wp !== 'undefined' && wp.apiFetch) {
                apiCall = wp.apiFetch({
                    path: '/coca-bais/v1/save-post-meta',
                    method: 'POST',
                    data: parsedData
                });
            } else if (typeof apiFetch !== 'undefined') {
                apiCall = apiFetch({
                    path: '/coca-bais/v1/save-post-meta',
                    method: 'POST',
                    data: parsedData
                });
            } else {
                // Fallback to jQuery AJAX
                apiCall = jQuery.ajax({
                    url: '/wp-json/coca-bais/v1/save-post-meta',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(parsedData),
                    beforeSend: function(xhr) {
                        // Add nonce if available
                        var nonce = jQuery('#_wpnonce').val() || jQuery('input[name="_wpnonce"]').val();
                        if (nonce) {
                            xhr.setRequestHeader('X-WP-Nonce', nonce);
                        }
                    }
                });
            }
            
            // Handle API response
            apiCall.then(function(response) {
                submitFormSafely(form, publishAction, false);
            }).catch(function(error) {
                console.error('Meta save failed:', error);
                
                var continueAnyway = confirm('Failed to save meta data. Do you want to continue anyway?');
                if (continueAnyway) {
                    submitFormSafely(form, publishAction, false);
                } else {
                    isProcessing = false;
                }
            });
        }
        
        // Reset button tracking
        lastClickedButton = null;
    });
    
    // Carousel form submission handler - simpler, just clears beforeunload warning
    jQuery('.post-type-coca_bais_carousel form#post').on('submit', function(event) {
        // Clear WordPress "unsaved changes" warning for carousel
        window.onbeforeunload = null;
        jQuery(window).off('beforeunload');
        
        // Let the form submit normally
        return true;
    });
    
    // Cross-browser safe form submission
    function submitFormSafely(form, isPublish, isRetry) {
        try {
            // Remove event handlers to prevent infinite loop
            jQuery(form).off('submit');
            jQuery('.post-type-coca_bais form#post input[type="submit"], .post-type-coca_bais form#post button[type="submit"]').off('click touchstart');
            
            // 🛠 FIX: Clear WordPress "unsaved changes" warning
            window.onbeforeunload = null;
            jQuery(window).off('beforeunload');
            
            if (isPublish) {
                // Set post status fields for different WordPress setups
                var statusFields = ['#post_status', '#original_post_status', '#hidden_post_status'];
                statusFields.forEach(function(selector) {
                    if (jQuery(selector).length) {
                        jQuery(selector).val('publish');
                    }
                });
                
                // Remove any existing hidden publish inputs
                jQuery('input[name="publish"][type="hidden"]').remove();
                
                // Add hidden publish input
                jQuery('<input>').attr({
                    type: 'hidden',
                    name: 'publish',
                    value: 'Publish'
                }).appendTo(form);
                
                // Set post action if field exists
                if (jQuery('#post_action').length) {
                    jQuery('#post_action').val('publish');
                }
            }
            
            // Cross-browser form submission
            var submitFunction = function() {
                isProcessing = false;
                
                // Try different submission methods
                if (form.submit && typeof form.submit === 'function') {
                    form.submit();
                } else {
                    // Fallback: create and click a submit button
                    var submitBtn = document.createElement('input');
                    submitBtn.type = 'submit';
                    submitBtn.style.display = 'none';
                    if (isPublish) {
                        submitBtn.name = 'publish';
                        submitBtn.value = 'Publish';
                    }
                    form.appendChild(submitBtn);
                    submitBtn.click();
                }
            };
            
            // Different browsers need different timing
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
                // Safari needs more delay
                setTimeout(submitFunction, 150);
            } else if (userAgent.indexOf('firefox') !== -1) {
                // Firefox can be immediate
                setTimeout(submitFunction, 10);
            } else {
                // Chrome and others
                setTimeout(submitFunction, 50);
            }
            
        } catch (e) {
            console.error('Form submission error:', e);
            isProcessing = false;
            
            // Ultimate fallback - reload page with query params
            if (!isRetry) {
                var url = window.location.href;
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'submit_failed=1';
                window.location.href = url;
            }
        }
    }
    
    // Reinitialize button capture after AJAX calls (for dynamic content)
    jQuery(document).ajaxComplete(function() {
        setTimeout(captureButtonClick, 100);
    });
    
    // Handle page visibility change (mobile browsers)
    if (document.addEventListener) {
        document.addEventListener('visibilitychange', function() {
            if (!document.hidden) {
                isProcessing = false; // Reset processing flag when page becomes visible
            }
        });
    }
});